<div class="accordion-item">
  <h3 class="accordion-header" id="headingOne">
    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#proRegulator"
      aria-expanded="true" aria-controls="companyDetails" (click)="showReg = !showReg"
      [ngClass]="{'collapsed':!showReg}">
      <span>Regulator</span>
      <div class="arrow"></div>
    </button>
  </h3>
  <div id="proRegulator" class="accordion-collapse collapse " aria-labelledby="proRegulator"
    [ngClass]="{'show':showReg}" [formGroup]="regDetailsForm">
    <ng-container formArrayName="regulatorArray">
      <div class="accordion-body">
        <div class="row" *ngFor="let regFormData of regulatorForm; let i = index" [formGroupName]="i">
          <div class="col-3 mb-3">
            <label for="proRegulatorInput" class="form-label">Regulator<span class="mandatory">*</span></label>
            <div [ngClass]="{'is-invalid' : submitted && regFormData?.controls?.['regulatorId']?.errors?.['required']}">
              <app-single-select uid="regulatoryId" [dataArr]="regulatorList"
                (selectedEvent)="selectedValue($event,'regulatorId',regFormData);" label="regulatoryAuthority"
                [selectedData]="regFormData.value.regulatorId" [placeholder]="'Select'">
              </app-single-select>
            </div>
            <span *ngIf="submitted && regFormData?.controls?.['regulatorId']?.errors?.['required']"
              class="invalid-feedback d-block" tabindex="0">This field is required</span>
          </div>

          <div class="col-2 mb-3">
            <label for="proFID" class="form-label">Facility ID/License#<span class="mandatory">*</span></label>
            <input autocomplete="disabled" type="text" id="proFID" class="form-control" formControlName="facility"
              [ngClass]="{'is-invalid' : (submitted && regFormData?.controls?.['facility']?.errors?.['required'])}"
              appPreventFirstSpace>
            <span *ngIf="(submitted && regFormData?.controls?.['facility']?.errors?.['required'])"
              class="invalid-feedback d-block" tabindex="0">This field is required</span>



          </div>

          <div class="col-3 mb-3">
            <label for="fromToDate" class="form-label">From Date - To Date<span class="mandatory">*</span></label>
            <div class="with-actions d-flex">
              <div class="w-100">
                <div>
                  <app-datepicker_v2 formControlName="date" [field]="validity_date_v2" [disabled]="isEdit" [isInValid]="(submitted && regFormData?.controls?.['date']?.errors?.['required']) || 
                  (regFormData?.controls?.['date']?.errors?.['validityPattern']) || (regFormData?.controls?.['date']?.errors?.['checkEndDate']) ||
                  (regFormData?.controls?.['date']?.errors?.['checkStartDate'])">
                  </app-datepicker_v2>
                </div>
                <span *ngIf="submitted && regFormData?.controls?.['date']?.errors?.['required']"
                  class="invalid-feedback d-block" tabindex="0">This field is required</span>
                <span *ngIf=" regFormData?.controls?.['date']?.errors?.['validityPattern']"
                  class="invalid-feedback d-block" tabindex="0">{{validationMsg}}</span>
                <span *ngIf=" regFormData?.controls?.['date']?.errors?.['checkEndDate']"
                  class="invalid-feedback d-block" tabindex="0">{{EndDateError}}</span>
                <span *ngIf=" regFormData?.controls?.['date']?.errors?.['checkStartDate']"
                  class="invalid-feedback d-block" tabindex="0">{{startDateError}}</span>
              </div>
              <ul class="actions  ml-1">
              </ul>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>